<!--NeumaticoCurvo-->
<template>
  <div class="relative">
    <div class="absolute left-1/2 text-lg -translate-x-1/2 top-2 md:top-5 flex uppercase text-white font-bold"
      id="tyre-text-container">
      <span class="number-one">225</span>
      <span>/</span>
      <span class="number-two">40</span>
      <span>R</span>
      <span class="number-three">17</span>
    </div>
    <img class="h-18 md:h-24 mx-auto" :src="'/img/home/neumaticos_v2.png'" alt="rueda-home-1" />
  </div>
</template>

<script setup>
</script>